//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FeaturedCheckbox',
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('input', value)
    }
  }
}
